/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react"
import { useLocation } from "react-router-dom"

import * as S from "./style"

const ContactButton = ({ label, size, onClick }) => {
  const location = useLocation()
  const lang = location.pathname.split("/")[1]

  return (
    <S.ContactButton to={`/${lang}/#contact`} size={size} onClick={onClick} gtmData={{ action: "contact", label: "navigate to form" }}>
      {label}
    </S.ContactButton>
  )
}

export default ContactButton
